/**
 * 自定义事件名称常量
 */
export const CUSTOM_EVENTS = {
  /** 自动更新用户订阅使用量事件 */
  AUTO_UPDATE_SUB_USAGE: 'auto-update-sub-usage',
} as const

export type CustomEventName = (typeof CUSTOM_EVENTS)[keyof typeof CUSTOM_EVENTS]
